<template>
  <div class="exclusive-discount">
    <SidebarLayout2 :breadcrumb="breadcrumb">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="sidebar-block">
          <PmwHeading size="paragraph-40">Ações da página</PmwHeading>
          <!-- BOTÕES DE AÇÃO -->
          <div class="sidebar-block--actions">
            <PmwButton
              :disabled="isSaveDisabled"
              variation="blue-100"
              @click="handleSaveClick"
            >
              Salvar
            </PmwButton>
            <PmwButton
              :link="'/desconto-exclusivo'"
              variation="blue-100"
              layout="outline"
              element="router-link"
            >
              Voltar sem salvar
            </PmwButton>
          </div>
        </SidebarBlock>
        <!-- DICAS -->
        <SidebarBlock class="sidebar-block--advice">
          <PmwHeading size="paragraph-40"> Dica </PmwHeading>
          <PmwParagraph>
            Os descontos exclusivos são uma ótima forma de incentivar a reserva
            para grupos de hóspedes específicos, como VIPs e recorrentes.
          </PmwParagraph>
        </SidebarBlock>
      </template>

      <template #content>
        <PmwHeading size="heading-60">Desconto exclusivo</PmwHeading>
        <PmwTitleWithLine
          title="Critérios de ativação"
          description="Configure a forma como o desconto será ativado no ambiente de pagamento"
          class="exclusive-discount--title"
        />
        <!-- CONTAINER NOME DESCONTO E STATUS DESCONTO -->
        <div class="exclusive-discount--name-status">
          <!-- NOME DO DESCONTO -->
          <FormInput
            v-model="discountName"
            :maxlength="100"
            label="Nome do desconto"
            placeholder="Insira o nome"
            class="exclusive-discount--input-discount-name"
            required
            showCounter
          />
          <!-- STATUS DESCONTO -->

          <div class="group-radio">
            <PmwParagraph
              size="paragraph-60"
              weight="medium"
              class="group-radio--subtitle"
            >
              Status do desconto
            </PmwParagraph>

            <div class="group-radio--row-checklist">
              <!-- ATIVO -->
              <PmwInputRadio
                :value="discountStatus"
                :checked="discountStatus"
                :inputValue="true"
                label="Ativo"
                name="discountStatus"
              />

              <!-- INATIVO -->
              <PmwInputRadio
                :value="discountStatus"
                :checked="!discountStatus"
                :inputValue="false"
                label="Inativo"
                name="discountStatus"
              />
            </div>
          </div>

          <!-- PERCENTUAL DESCONTO -->
          <PmwFormInput
            v-model="discountPercent"
            :required="true"
            :hasMask="true"
            :showErrorFeedbackMessage="true"
            :error="discountPercent > 100"
            :feedbackMessage="
              discountPercent > 100
                ? 'O percentual não pode ser maior que 100%'
                : ''
            "
            mask="###"
            max="100"
            sufix="%"
            label="Digite o percentual do desconto"
            placeholder="Digite o percentual"
            class="exclusive-discount--input-percent"
          />
        </div>

        <!-- TIPO DE APLICAÇÃO DE DESCONTO -->
        <FormField label="Tipo de aplicação de desconto" required>
          <div class="exclusive-discount--discount-aplication">
            <div class="exclusive-discount--row-checklist">
              <!-- GRUPOS CRM -->
              <PmwInputRadio
                v-model="discountAplicationMode"
                :checked="discountAplicationMode === 0"
                :inputValue="0"
                :disabled="consumers.length > 0"
                label="Grupos CRM"
                name="discount-aplication"
                @change="handleDiscountTypeChange(0)"
              />

              <!-- CONSUMERS -->
              <PmwInputRadio
                v-model="discountAplicationMode"
                :checked="discountAplicationMode === 1"
                :inputValue="1"
                :disabled="groupsValues.gruposCrm.length > 0"
                label="Consumers"
                name="discount-aplication"
                @change="handleDiscountTypeChange(1)"
              />

              <!-- DESKTOP -->
              <PmwInputRadio
                v-model="discountAplicationMode"
                :checked="discountAplicationMode === 2"
                :inputValue="2"
                :disabled="groupsValues.gruposCrm.length > 0"
                label="Desktop"
                name="discount-aplication"
                @change="handleDiscountTypeChange(2)"
              />

              <!-- MOBILE -->
              <PmwInputRadio
                v-model="discountAplicationMode"
                :checked="discountAplicationMode === 3"
                :inputValue="3"
                :disabled="groupsValues.gruposCrm.length > 0"
                label="Mobile"
                name="discount-aplication"
                @change="handleDiscountTypeChange(3)"
              />
            </div>
          </div>
        </FormField>

        <!-- GRUPOS CRM SENDO EXIBIDOS -->
        <Transition name="fade">
          <div
            v-if="discountAplicationMode === 0 && groupsValues.gruposCrm"
            class="exclusive-discount--groups-crm"
          >
            <PmwFormField
              label="Selecione os grupos de CRM que deseja aplicar o
              desconto"
            >
              <CRMGroupsForm
                v-model="groupsValues"
                :isOpen="discountAplicationMode === 0"
                :showTitle="false"
                showSelectedGroupsList
              />
            </PmwFormField>
          </div>
        </Transition>

        <!-- CONSUMERS SENDO EXIBIDOS -->
        <Transition name="fade">
          <div
            v-if="discountAplicationMode === 1"
            class="exclusive-discount--consumers"
          >
            <PmwComboInput
              v-model="consumers"
              :buttonHasIcon="true"
              buttonLayout="outline"
              label="Digite os consumers"
              placeholder="Digite os consumers"
              maxlength="50"
              showCounter
            />
          </div>
        </Transition>

        <!-- CRITÉRIOS ADICIONAIS -->
        <PmwTitleWithLine
          title="Critérios adicionais"
          description="Configure as tarifas que receberão o desconto"
          class="exclusive-discount--title"
        />

        <!-- SELECT HOTEL -->
        <PmwFormSelect
          v-model="selectHotels"
          :options="hotelOptions"
          :search="true"
          :required="true"
          :multiple="true"
          searchPlaceholder="Pesquise aqui"
          label="Selecione os hotéis"
          placeholder="Selecione os hotéis"
          class="exclusive-discount--select-hotels"
        />

        <!-- APLICAR EM QUAIS TARIFAS? -->
        <div class="exclusive-discount--row-checklist">
          <!-- TODAS TARIFAS -->
          <PmwInputRadio
            v-model="applyAtAllRates"
            :checked="applyAtAllRates"
            :inputValue="true"
            label="Aplicar sobre todas as tarifas"
            name="applyAtAllRates"
          />

          <!-- TARIFAS SELECIONADAS -->
          <PmwInputRadio
            v-model="applyAtAllRates"
            :checked="!applyAtAllRates"
            :inputValue="false"
            label="Aplicar sobre tarifas selecionadas"
            name="applyAtAllRates"
          />
        </div>

        <!-- SELECT TARIFAS APLICAVEIS -->
        <FormSelectCoupon
          v-show="!applyAtAllRates"
          v-model="selectRates"
          :options="ratesOptionsBySelectedHotels"
          labelKey="descricao"
          valueKey="codigo"
          tooltipMinWidth="170"
          label="Tarifas aplicáveis"
          placeholder="Selecione as tarifas"
          searchPlaceholder="Pesquise aqui"
          name="tarifas"
          class="exclusive-discount--select-tarifas"
          search
          multiple
          toggleAll
          showCounter
          loadOnDemand
          required
        />

        <!-- PERIODO DE ATIVAÇÃO -->
        <PmwTitleWithLine
          title="Período de ativação"
          description="Configure o período em que o desconto estará disponível"
          class="exclusive-discount--title"
        />

        <div class="exclusive-discount--row-date">
          <!-- PERIODO DE RESERVA DATA PICKER -->
          <PmwComboInput
            v-model="reservationPeriod"
            :disabled="reservationPeriod.length >= 1"
            :disabledRemoveInherit="false"
            label="Período de reserva"
            comboType="date"
            placeholder="dd/mm/aaaa - dd/mm/aaaa"
            dateFormat="dd MMM yyyy"
            size="large"
            range
          >
            <template slot="button-content">
              Adicionar
            </template>
          </PmwComboInput>

          <!-- PERIODO DE HOSPEDAGEM DATA PICKER -->
          <PmwComboInput
            v-model="stayPeriodDates"
            label="Período de hospedagem"
            comboType="date"
            placeholder="dd/mm/aaaa - dd/mm/aaaa"
            buttonLayout="outline"
            dateFormat="dd MMM yyyy"
            size="large"
            range
          />
        </div>

        <SeparateLine :top="25" :left="0" :right="0" :bottom="25" />

        <div class="exclusive-discount--input-area">
          <PmwButton
            :link="'/desconto-exclusivo'"
            element="router-link"
            size="fluid"
            class="exclusive-discount--action-btn"
            layout="outline"
            variation="blue-100"
          >
            Voltar sem salvar
          </PmwButton>

          <PmwButton
            :disabled="isSaveDisabled"
            size="fluid"
            class="exclusive-discount--action-btn"
            variation="blue-100"
            @click="handleSaveClick"
          >
            Salvar
          </PmwButton>
        </div>
        <!-- MODAL DESATIVAR -->
        <PmwAlertModal
          v-model="showModal"
          title=""
          icon="alert"
          cancelButtonText="Voltar e revisar"
          confirmButtonText="Salvar e continuar"
          confirmButtonColor="blue-100"
          closeButton
          @alert-modal-confirm="showSaveAlertModal = true"
          @alert-modal-cancel="showModal = false"
        >
          <template #text>
            <div class="modal--container-content">
              <PmwHeading class="modal--title">Atenção</PmwHeading>
              <PmwParagraph size="paragraph-60" class="modal--paragraph">
                O percentual de desconto foi maior ou igual 50%. Caso esteja
                correto, o percentual será aplicado sobre o valor total,
                considerando os demais descontos das tarifas. Deseja continuar?
              </PmwParagraph>
            </div>
          </template>
        </PmwAlertModal>

        <SaveAlertModal
          v-model="showSaveAlertModal"
          icon="alert"
          cancelButtonText="Voltar e revisar"
          confirmButtonText="Salvar"
          buttonClose
          preventOverlayClick
          @alert-modal-confirm="saveExclusiveDiscount"
          @alert-modal-cancel="showSaveAlertModal = false"
        />
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton/PmwButton.vue'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading/PmwHeading.vue'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwTitleWithLine from '@solucoes/components-lib-tmp/src/components/elements/PmwTitleWithLine/PmwTitleWithLine.vue'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwInputRadio from '@solucoes/components-lib-tmp/src/components/elements/PmwInputRadio/PmwInputRadio.vue'
import CRMGroupsForm from '@/components/rates/master/CRMGroupsForm.vue'
import PmwComboInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwComboInput/PmwComboInput.vue'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect/PmwFormSelect.vue'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import { formatISO } from 'date-fns'
import FormField from '@solucoes/components-lib-tmp/src/components/patterns/FormField'
import FormSelectCoupon from '@/components/_base/elements/FormSelectCoupon/FormSelectCoupon.vue'
import SaveAlertModal from '@/components/exclusive-discounts/SaveAlertModal.vue'
import PmwFormField from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormField/PmwFormField.vue'

export default {
  name: 'CreateDiscount',

  components: {
    SidebarLayout2,
    SidebarBlock,
    PmwHeading,
    PmwButton,
    PmwParagraph,
    PmwTitleWithLine,
    FormInput,
    PmwInputRadio,
    CRMGroupsForm,
    PmwComboInput,
    PmwFormSelect,
    SeparateLine,
    PmwAlertModal,
    FormField,
    FormSelectCoupon,
    SaveAlertModal,
    PmwFormInput,
    PmwFormField
  },

  data() {
    return {
      breadcrumb: [
        {
          label: 'Letsbook'
        },
        {
          label: 'Listagem de descontos exclusivos',
          url: '/desconto-exclusivo',
          isSpa: true
        },
        {
          label: 'Criar desconto exclusivo'
        }
      ],
      discountStatus: true,
      applyAtAllRates: false,
      groupsValues: {
        gruposCrm: []
      },
      consumers: [],
      selectHotels: [],
      selectRates: [],
      optionsRates: [],
      reservationPeriod: [],
      stayPeriodDates: [],
      exclusiveDiscountId: null,
      discountName: '',
      discountPercent: '',
      hotelOptions: [],
      showModal: false,
      showSaveAlertModal: false,
      /** Tipo de aplicação do desconto: 0 - CRM, 1 - Consumer, 2 - Desktop, 3 - Mobile */
      discountAplicationMode: 1
    }
  },

  computed: {
    isSaveDisabled() {
      const isEmpty = (val) =>
        val === null ||
        val === undefined ||
        val === '' ||
        (Array.isArray(val) && val.length === 0)

      const requiredFieldsValid =
        !isEmpty(this.discountName) &&
        !isEmpty(this.discountPercent) &&
        !(this.discountPercent < 1 || this.discountPercent > 100) &&
        !isEmpty(this.selectHotels) &&
        (!isEmpty(this.selectRates) || this.applyAtAllRates) &&
        (!isEmpty(this.groupsValues.length > 0) ||
          !isEmpty(this.consumers.length > 0))

      return !requiredFieldsValid
    },

    /** Retorna as opções de tarifas de acordo com os hotéis selecionados */
    ratesOptionsBySelectedHotels() {
      const rates = this.optionsRates.filter((option) =>
        this.selectHotels.find((hotel) => hotel.value === option.codigo)
      )

      if (rates.length) return rates

      return this.optionsRates
    }
  },

  watch: {
    /**
     * Limpa a lista de tarifas selecionadas quando o checkbox "Aplicar sobre todas as tarifas" é marcado
     * @param {boolean} applyToAll - Valor do checkbox "Aplicar sobre todas as tarifas"
     */
    applyAtAllRates(applyToAll) {
      if (applyToAll) {
        this.selectRates = []
      }
    },

    selectHotels(newVal) {
      const selectedHotels = this.optionsRates.filter((optRate) =>
        newVal.find((nv) => nv.value === optRate.codigo)
      )

      this.selectRates = this.selectRates.filter((rate) =>
        selectedHotels.find((optHotel) =>
          optHotel.options.find((opt) => opt.codigo === rate.codigo)
        )
      )
    }
  },

  async created() {
    this.exclusiveDiscountId = this.$route.params.id || null

    this.setLoadingBar(true)

    await this.getHotels()

    await this.getExlusiveDiscountById()

    this.setLoadingBar(false)
  },

  methods: {
    ...mapActions(['setLoadingBar']),

    handleSaveClick() {
      if (this.discountPercent >= 50) {
        this.showModal = true
      } else {
        this.showSaveAlertModal = true
      }
    },

    getRates() {
      const cupomId = this.exclusiveDiscountId || ''

      return this.$coupon
        .getAvailableRates(cupomId, '')
        .then((response) => {
          this.optionsRates = response.data.reduce((acc, item) => {
            if (!item.tarifas.length) return acc

            item.options = item.tarifas

            acc.push(item)

            return acc
          }, [])
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error[0].message
          })
        })
    },

    /** Busca os dados de um desconto exclusivo pelo ID e popula os campos do formulário. */
    async getExlusiveDiscountById() {
      if (!this.exclusiveDiscountId) return

      await this.$exclusiveDiscounts
        .getDiscountById(this.exclusiveDiscountId)
        .then(({ data }) => {
          /** Dados básicos do desconto: Nome, Status desconto, Porcentagem */
          this.discountName = data.desconto || ''
          this.discountStatus = data.ativo ?? true
          this.discountPercent = data.valor || 0

          /** Hoteis selecionados */
          this.selectHotels = Array.isArray(data.hoteis)
            ? data.hoteis
                .map((hotelId) => {
                  /** Procura o hotel pelo id dentro da lista de opções de hotéis */
                  const hotel = this.hotelOptions.find(
                    (h) => h.value === hotelId
                  )
                  /** Se o hotel não for encontrado, retorna um objeto de erro */
                  return (
                    hotel || { value: hotelId, text: 'Hotel não encontrado' }
                  )
                })
                .filter(
                  (value, index, self) =>
                    /** Remove hotéis duplicados com base no valor (id) */
                    index === self.findIndex((t) => t.value === value.value)
                )
            : []

          /** integrar corretamente com o valor da API */
          this.discountAplicationMode = data.gruposCrm.length > 0 ? 0 : 1

          /** Se desconto por device */
          if (data.devices.length) {
            this.discountAplicationMode = data.devices[0] === 0 ? 2 : 3
          }

          /** Consumidores */
          this.consumers = Array.isArray(data.consumers) ? data.consumers : []

          /** Grupos CRM */
          this.groupsValues.gruposCrm = data.gruposCrm ?? []

          /** Tarifas selecionadas */
          if (data.flutuacoesTarifarias.length === 0) {
            this.applyAtAllRates = true
            this.selectRates = []
          } else {
            /** Mapeia as tarifas selecionadas, associando cada código com um objeto de tarifa */
            const codigoMap = new Map(
              this.optionsRates
                .flatMap((rate) => rate.options)
                .map((opt) => [opt.codigo, opt])
            )

            this.selectRates = data.flutuacoesTarifarias
              .map((codigo) => codigoMap.get(codigo))
              .filter(Boolean)
          }

          /** Seta os períodos da reserva */
          this.reservationPeriod = data.periodosReserva?.[0]
            ? [
                {
                  start: new Date(
                    `${data.periodosReserva[0].dataInicio}T00:00:00`
                  ),
                  end: new Date(`${data.periodosReserva[0].dataFim}T23:59:59`)
                }
              ]
            : []

          /** Seta os períodos de hospedagem */
          this.stayPeriodDates = data.periodosHospedagem.map((date) => ({
            start: new Date(`${date.dataInicio}T00:00:00`),
            end: new Date(`${date.dataFim}T23:59:59`)
          }))

          this.setLoadingBar(false)
        })
        .catch(() => {
          this.setLoadingBar(false)

          /** Caso haja erro ao buscar os dados, exibe uma mensagem de erro */
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao buscar desconto exclusivo'
          })
        })
    },

    /** Método chamado quando o usuário altera o tipo de desconto
     * @param {number} type - 0 - CRM, 1 - Consumer, 2 - Desktop, 3 - Mobile
     * TODO atualizar esse método para suportar múltiplos valores
     */
    handleDiscountTypeChange(type) {
      this.discountAplicationMode = +type
    },

    /** Busca a lista de hotéis para o filtro */
    async getHotels() {
      await this.$initialSetting
        .getHotels({ ativo: true })
        .then(async (response) => {
          const data = response.data

          this.hotelOptions = data.map((item) => {
            return {
              value: item.codigo,
              text: item.nome
            }
          })
          await this.getRates()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao buscar hotéis'
          })
        })
    },

    /** Envia payload para API */
    async saveExclusiveDiscount() {
      this.showSaveAlertModal = false

      const nomeRequisicao = this.exclusiveDiscountId
        ? 'updateExclusiveDiscount'
        : 'insertNewDiscount'

      const payload = this.buildPayload()

      await this.$exclusiveDiscounts[nomeRequisicao](payload)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Desconto salvo com sucesso!'
          })
          this.$router.push('/desconto-exclusivo')
        })
        .catch((erro) => {
          const message = erro.response.data
            .flatMap((item) => item.message)
            .join('\n')

          this.$bus.$emit('show-alert-chip', {
            message
          })
        })
    },

    /**
     * Monta o payload com base nos campos preenchidos do formulário.
     * @returns {Object} Payload para envio à API
     */
    buildPayload() {
      /** Tarifas selecionadas ou vazio se aplicar a todas */
      const tarifasFormatadas = this.applyAtAllRates
        ? []
        : this.selectRates.map((r) => r?.codigo)

      /** Grupos CRM únicos, se aplicar por hotel */
      const gruposCrmFormatados =
        this.discountAplicationMode === 0 && this.groupsValues?.gruposCrm
          ? this.groupsValues.gruposCrm
          : []

      /** Consumidores, se não aplicar por hotel */
      const consumersFormatados =
        this.discountAplicationMode === 1 && Array.isArray(this.consumers)
          ? this.consumers
          : []

      /** Tipo de dispositivo ao que o desconto vai ser aplicado, Device */
      const formatedDevices =
        this.discountAplicationMode === 2
          ? 0
          : this.discountAplicationMode === 3
          ? 1
          : null

      /** IDs dos hotéis selecionados */
      const hoteisFormatados = Array.isArray(this.selectHotels)
        ? this.selectHotels.map((hotel) => hotel.value)
        : []

      /** Período de hospedagem formatado */
      const periodosHospedagemFormatado = [
        ...this.stayPeriodDates.map((dateObj) => ({
          dataInicio: formatISO(dateObj.start, { representation: 'date' }),
          dataFim: formatISO(dateObj.end, { representation: 'date' })
        }))
      ]

      /** Período de reserva formatado */
      const periodosReservaFormatado = this.reservationPeriod?.[0]
        ? [
            {
              dataInicio: formatISO(this.reservationPeriod[0].start, {
                representation: 'date'
              }),
              dataFim: formatISO(this.reservationPeriod[0].end, {
                representation: 'date'
              })
            }
          ]
        : []

      /** Monta o objeto com os dados do desconto */
      const payload = {
        desconto: this.discountName,
        ativo: this.discountStatus,
        valor: this.discountPercent,
        gruposCrm: gruposCrmFormatados,
        consumers: consumersFormatados,
        devices: formatedDevices !== null ? [formatedDevices] : null,
        hoteis: hoteisFormatados,
        tarifas: tarifasFormatadas,
        periodosHospedagem: periodosHospedagemFormatado,
        periodosReserva: periodosReservaFormatado
      }

      /** Adiciona ID se for uma atualização */
      if (this.exclusiveDiscountId) {
        payload.codigo = this.exclusiveDiscountId
      }

      return payload
    }
  }
}
</script>

<style lang="scss" scoped>
.exclusive-discount {
  &--action-btn {
    max-width: 214px;
  }

  &--discount-aplication {
    margin-top: pmw-space(2);
    margin-bottom: 20px;
  }

  &--subtitle {
    margin-bottom: 30px;
  }

  &--row-checklist {
    display: flex;
    gap: 16px;
    margin-bottom: 35px;
  }

  &--subtitle-group {
    margin: -10px 0px 10px 0px;
    color: $pmw-red-2;
  }

  &--input-area {
    display: flex;
    justify-content: space-between;
    gap: 600px;
  }

  &--row-date {
    display: flex;
    flex-direction: row;
    gap: 25px;
  }

  &--title {
    margin-bottom: 40px;
  }
  .sidebar-block {
    &--actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &--advice {
      ::v-deep .pmw-paragraph {
        line-height: 21px;
      }
    }
  }
  &--select-hotels {
    max-width: 435px;
    margin-bottom: 30px;
  }
  &--select-tarifas {
    max-width: 435px;
    margin: 30px 0px;
  }

  &--name-status {
    display: flex;
    align-items: flex-start;
    margin-bottom: 32px;
    gap: 70px;
  }

  &--input-discount-name {
    max-width: 370px;
  }

  &--input-percent {
    max-width: 250px;
  }

  .pmw-input-radio ::v-deep {
    input:checked ~ {
      .pmw-input-radio--fake-radio {
        border-color: $pmw-blue;

        &:before {
          background-color: $pmw-blue;
        }
      }
    }
  }
}

.pmw-form-field {
  ::v-deep {
    /** Alterar as cores novas do form-input */
    .pmw-input {
      background-color: $white;
    }

    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }

    .pmw-input__focus {
      border-color: pmw-colors('blue-100');
    }

    .pmw-input--field {
      padding: 1px 0;

      &:focus {
        border-color: pmw-colors('blue-100');
      }
    }
  }
}

.group-radio {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 30px;

  &--row-checklist {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-bottom: 30px;
  }
}
</style>
